module.exports = __webpack_public_path__ + "img/vol03_cup02_badge.5716ce4a.png";